import PropTypes from 'prop-types';
import { useProperty, useTranslation } from '@eti/providers';
import { BoundNew } from '@eti/types';
import TrustInformation from '../../../../common/components/TrustInformation';
import { getMarketingCarrierNames } from '../../utils/carriers';

const TrustInformationNotification = ({ bounds }) => {
  const { p } = useProperty();
  const { t } = useTranslation();

  const marketingCarriersLabel =
    getMarketingCarrierNames(bounds).length > 1
      ? getMarketingCarrierNames(bounds).join(', ')
      : getMarketingCarrierNames(bounds)[0];

  return p('TD.TrustInformation.Enabled') ? (
    <TrustInformation
      content={t('TD.TrustInformation.Text')}
      header={t('TD.TrustInformation.Header', marketingCarriersLabel)}
    />
  ) : null;
};

TrustInformationNotification.propTypes = {
  bounds: PropTypes.arrayOf(BoundNew),
};

export default TrustInformationNotification;
